exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".livefeed-svg-gauge,.livefeed-svg-gauge-label{width:100%;overflow:visible!important;top:0;left:0;transition:all .4s ease}.livefeed-svg-gauge-label .needle,.livefeed-svg-gauge-label circle,.livefeed-svg-gauge .needle,.livefeed-svg-gauge circle{transition:all .4s ease}.livefeed-svg-gauge-label text,.livefeed-svg-gauge text{text-anchor:middle;alignment-baseline:middle;dominant-baseline:middle;transition:all .4s ease}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?-autoprefixer!./~/postcss-loader/src!./~/less-loader!./src/components/pages/livefeed/Editor/EditorContainer/common/Gauge/index.less
// module id = 1989
// module chunks = 0